import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
const _hoisted_2 = {
  "clip-path": "url(#clip0_5057_254012)"
};
const _hoisted_3 = ["stroke"];
const _hoisted_4 = ["stroke"];
const _hoisted_5 = /*#__PURE__*/_createElementVNode("defs", null, [/*#__PURE__*/_createElementVNode("clipPath", {
  id: "clip0_5057_254012"
}, [/*#__PURE__*/_createElementVNode("rect", {
  width: "11",
  height: "11",
  fill: "white",
  transform: "translate(12 4)"
})])], -1);
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("svg", _hoisted_1, [_createElementVNode("g", _hoisted_2, [_createElementVNode("path", {
    d: "M17.5 4.91797L18.4221 7.31555C18.5514 7.65161 18.616 7.81964 18.7165 7.96098C18.8056 8.08625 18.915 8.1957 19.0403 8.28477C19.1816 8.38527 19.3497 8.4499 19.6857 8.57916L22.0833 9.5013L19.6857 10.4234C19.3497 10.5527 19.1816 10.6173 19.0403 10.7178C18.915 10.8069 18.8056 10.9164 18.7165 11.0416C18.616 11.183 18.5514 11.351 18.4221 11.6871L17.5 14.0846L16.5778 11.6871C16.4486 11.351 16.384 11.183 16.2835 11.0416C16.1944 10.9164 16.0849 10.8069 15.9597 10.7178C15.8183 10.6173 15.6503 10.5527 15.3142 10.4234L12.9167 9.5013L15.3142 8.57916C15.6503 8.4499 15.8183 8.38527 15.9597 8.28477C16.0849 8.1957 16.1944 8.08625 16.2835 7.96098C16.384 7.81964 16.4486 7.65161 16.5778 7.31555L17.5 4.91797Z",
    stroke: $props.color,
    "stroke-width": "1.4",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  }, null, 8, _hoisted_3)]), _createElementVNode("path", {
    d: "M14.25 14.2493C14.0447 14.2493 13.8427 14.2356 13.6447 14.2089C13.3191 14.1652 13.1563 14.1433 13.0533 14.158C12.946 14.1734 12.8882 14.1929 12.7936 14.2458C12.7027 14.2965 12.6133 14.386 12.4343 14.5649L11.25 15.7493H9.75V17.2493H8.25V18.7493H6.45C6.02996 18.7493 5.81994 18.7493 5.65951 18.6676C5.51839 18.5956 5.40365 18.4809 5.33175 18.3398C5.25 18.1794 5.25 17.9693 5.25 17.5493V16.2464C5.25 16.0629 5.25 15.9712 5.27072 15.8849C5.2891 15.8083 5.3194 15.7352 5.36052 15.6681C5.4069 15.5924 5.47176 15.5275 5.60147 15.3978L9.43435 11.5649C9.61328 11.386 9.70275 11.2965 9.75352 11.2057C9.8064 11.1111 9.82594 11.0533 9.84129 10.946C9.85602 10.843 9.83413 10.6802 9.79036 10.3546C9.76374 10.1566 9.75 9.95456 9.75 9.7493C9.75 7.67838 11.1489 5.93419 13.0533 5.41016",
    stroke: $props.color,
    "stroke-width": "1.4",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  }, null, 8, _hoisted_4), _hoisted_5]);
}